import { useEffect, useState } from 'react'
import { useIsMobile } from '@centered/components/dist/hooks/useIsMobile'
import GoogleAuthCta from './GoogleAuthCta'

interface FloatingCtaProps {
  source: string
  noGoogleAuthSource: string
}

export default function FloatingCta({
  source,
  noGoogleAuthSource,
}: FloatingCtaProps): JSX.Element | null {
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = 
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      setIsVisible(scrollPercentage >= 25)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Don't render on mobile
  if (isMobile || isDismissed) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 50,
        bottom: '2rem',
        right: '2rem',
        width: '320px',
        transition: 'all 1000ms cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(1rem)',
        pointerEvents: isVisible ? 'auto' : 'none'
      }}
    >
      <div className="relative bg-black text-white rounded-lg p-6 shadow-lg">
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute top-2 right-2 text-white/60 hover:text-white"
          aria-label="Close"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <h3 className="text-xl font-semibold mb-4">Save time with Sukha</h3>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <GoogleAuthCta
            source={source}
            noGoogleAccountSource={noGoogleAuthSource}
          />
          <a
            href="https://www.TheSukha.co/"
            className="text-white/80 hover:text-white text-sm transition-colors whitespace-nowrap"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  )
}
